
import { NotificationMessage } from '../notification-message/notification-message';
import styles from './suggestion-summary.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  CcfAccordion,
  CcfAccordionDetails,
  CcfAccordionSummary,
  CcfBookOpenIcon,
  CcfDoubleArrowIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import {
  ccfrtigActions,
  selectIsGuidanceScoreExpanded,
  selectIsSuggestionSummaryExpanded,
  selectsuggestionsList,
} from '../+state/ccf-rtig.slice';
import { useEffect, useRef, useState } from 'react';
import { activeContactSelector } from '../../ccf-inbox/ccf-inbox.slice';
import CcfRtigAccordionStyles from '../ccf-rtig-accordion.styles';
import { useTheme}  from '@mui/material';

/* eslint-disable-next-line */
export interface SuggestionSummaryProps {
}

/**
 * Component to provide Suggsestion summary for agent
 * @param param0 - SuggestionSummaryProps
 * @example - <SuggestionSummary />
 * @returns
 */
export function SuggestionSummary(props: any) {
  const suggestionSummaryDiv = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const suggestionsObj = useSelector(selectsuggestionsList);
const activeContact = useSelector(activeContactSelector);
  const [suggestionsList, setsuggestionsList] = useState(suggestionsObj);
  const isSuggestionSummaryExpanded = useSelector(
    selectIsSuggestionSummaryExpanded
  );
  const isGuidanceScoreExpanded = useSelector(selectIsGuidanceScoreExpanded);
  const {
    setGuidanceScoreExapnded,
    setSuggestionSummaryExapnded,
    updateSuggestionList,
  } = ccfrtigActions;
  const [viewMore, SetViewMore] = useState(false);
  const theme = useTheme();
  const simStyles = CcfRtigAccordionStyles(theme);
  
  useEffect(() => {
    setsuggestionsList(suggestionsObj);
  }, [suggestionsObj]);

  /**
   * Component to render notification messgae inside suggestion summary
   * @param param - 
   * @example - renderNotificationMessages()
   * @returns
   */
  const renderNotificationMessages = () => {
    return (
      <div className="row suggestion-items-container">
        {suggestionsList.map((notification: any, i: number) => (
          <NotificationMessage
            suggestionItem={notification}
            key={i}
            id={i}
            suggestionRemoveCallback={suggestionRemoveCallback}
            highLightColor={notification.highLight ? true : false}
          />
        ))}
      </div>
    );
  };

  /**
   * function to remove suggestion item from list
   * @param param0 - id
   * @example - suggestionRemoveCallback()
   * @returns
   */
  const suggestionRemoveCallback = (id: number) => {
    setsuggestionsList(
      suggestionsList.filter(
        (item: any) => item.label !== suggestionsList[id].label
      )
    );
    setsuggestionsList((state: any) => {
      return dispatch(updateSuggestionList(state)).payload;
    });
  };

  /**
   * Function to be called on accordion click for toggling
   * @param param0 - 
   * @example - onAccodianClick()
   * @returns
   */
  const onAccodianClick = () => {
    dispatch(setSuggestionSummaryExapnded(!isSuggestionSummaryExpanded));
    //dispatch(setGuidanceScoreExapnded(!isGuidanceScoreExpanded));
  };

  /**
   * Function to toggle view more link
   * @param param0 - param
   * @example - onViewMoreClick()
   * @returns
   */
  const onViewMoreClick = (param: boolean) => {
   // console.log(suggestionSummaryDiv.current);
    document.getElementById('suggestionSummaryDiv')?.scroll({
      top: 0, //scroll to the bottom of the element
      behavior: 'smooth' //auto, smooth, initial, inherit
    });
    SetViewMore(!param);
  };

  return (
    <div className={styles['suggestionSummary']}>
      {suggestionsList.length > 0 && (
        <CcfAccordion
          sx={simStyles.accordionContainer}
          expanded={isSuggestionSummaryExpanded}
          onChange={onAccodianClick}
        >
          <CcfAccordionSummary
            expandIcon={<CcfDoubleArrowIcon sx={simStyles.expandedIcon} />}
            aria-controls="suggestionSummary-content"
            id="suggestionSummary-header"
            sx={simStyles.accordionHeader}
          >
            <CcfTypography className="txt-suggestion-summary">
              Suggestion Summary
            </CcfTypography>
          </CcfAccordionSummary>
          <CcfAccordionDetails id="suggestionSummaryDiv"
            classes={{ root: styles.setAccordionDetailsItem }}
            style={{
              maxHeight: '41vh',
              overflow: !viewMore ? 'hidden' : 'scroll',
              marginLeft: '5px',
            }}
          >
            {renderNotificationMessages()}
          </CcfAccordionDetails>
          {suggestionsList.length > 4 && (
            <CcfTypography
              onClick={() => onViewMoreClick(viewMore)}
              className="txt-view-more"
            >
              {!viewMore ? 'View More' : 'View Less'}
            </CcfTypography>
          )}
        </CcfAccordion>
      )}

      {suggestionsList.length === 0 && (
        <CcfAccordion
          sx={simStyles.accordionContainer }
          expanded={isSuggestionSummaryExpanded}
          onChange={onAccodianClick}
        >
          <CcfAccordionSummary
            expandIcon={<CcfDoubleArrowIcon sx={simStyles.expandedIcon} />}
            aria-controls="no-suggestions-header"
            id="no-suggestions-header"
            sx={simStyles.accordionHeader}
          >
            <CcfTypography className="txt-suggestion-summary">
              Suggestion Summary
            </CcfTypography>
          </CcfAccordionSummary>
          <CcfAccordionDetails className="no-suggestions">
            <CcfBookOpenIcon className="book-open-icon" />
            <CcfTypography className="txt-no-suggestion">
              You don't have any new suggestions.
            </CcfTypography>
          </CcfAccordionDetails>
        </CcfAccordion>
      )}
    </div>
  );
}

export default SuggestionSummary;
